import {
  CartCheckoutClient,
  ResponseError,
} from '@app/data/clients/cartCheckoutClient';
import {
  DispatchActionsType,
  StateDispatch,
} from '@app/data/clients/cartCheckoutClient/CartAndDeliveryDatesDataContext/types';
import {
  RemoveCouponHandlerOptions,
  RemoveCouponHandlerResult,
} from '@app/types/cart/Coupon';
import { isRemoveCouponAPISuccess } from '@app/types/monolith/utils';
import { useCallback, useState } from 'react';

const formatRemoveCouponError = (error: {
  error_code?: string;
  error_params?: Record<string, string>;
}) => {
  const field = ['cart', 'coupon'];
  return { ...error, field };
};

export const useRemoveCouponHandler = (
  client: CartCheckoutClient,
  dispatch: StateDispatch
): RemoveCouponHandlerResult => {
  const [isLoading, setIsLoading] = useState(false);

  const handler = useCallback(
    async (options: RemoveCouponHandlerOptions) => {
      setIsLoading(true);

      return client
        .removeCoupon(options.input, options.signal)
        .then((monolithRes) => {
          if (isRemoveCouponAPISuccess(monolithRes)) {
            dispatch({
              type: DispatchActionsType.SET_CART,
              payload: monolithRes.cart,
            });
            options.onCompleted?.({ errors: [] });
          } else {
            options.onCompleted?.({
              errors: [formatRemoveCouponError(monolithRes)],
            });
          }
        })
        .catch((error) => {
          if (error instanceof ResponseError) {
            options.onError?.({ responseError: error });
            return;
          }
          options.onError?.({});
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [client.removeCoupon, dispatch]
  );

  return {
    handler,
    isLoading,
  };
};
